import React from 'react';
import { EventBlock } from './EventBlock';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { EventBlockDimensions, EventBlockGridDimensions } from '../dimensions.consts';
import { View } from '@amzn/atoz-web/View';
import { WEEKLY_SCHEDULE_EVENT_BLOCK_GRID, getEventBlockWrapperTestId } from '../testids.consts';
import { getSplitsForEvent } from '../utils';
export var getGridRowPosition = function (time) {
    if (!time.isValid)
        return null;
    return (time.hour * EventBlockGridDimensions.hour.numsOfRow +
        time.minute * EventBlockGridDimensions.minute.numsOfRow +
        EventBlockGridDimensions.rowOffset);
};
export var getGridColumnPosition = function (date, dates) {
    var eventDayIndex = dates.indexOf(date);
    if (eventDayIndex === -1)
        return null;
    var arrayIndexOffset = 1;
    return (eventDayIndex + arrayIndexOffset + EventBlockGridDimensions.columnOffset);
};
export var getEventBlockHeight = function (rowStart, rowEnd, splitAtTop, splitAtBottom) {
    var height = (rowEnd - rowStart) * EventBlockGridDimensions.minute.height;
    if (splitAtTop)
        height -= EventBlockDimensions.borderWidth;
    if (splitAtBottom)
        height -= EventBlockDimensions.borderWidth;
    return height;
};
export var EventBlockGrid = function (_a) {
    var eventsByDateMap = _a.eventsByDateMap, weeklyDates = _a.weeklyDates;
    return (React.createElement(EventBlockGridWrapper, { dataTestId: WEEKLY_SCHEDULE_EVENT_BLOCK_GRID }, weeklyDates.map(function (date) {
        var detailedEvent = eventsByDateMap.get(date);
        return detailedEvent === null || detailedEvent === void 0 ? void 0 : detailedEvent.map(function (detailedEvent) {
            var startTime = detailedEvent.startTime, endTime = detailedEvent.endTime, id = detailedEvent.id;
            var gridRowStart = getGridRowPosition(startTime);
            var gridRowEnd = getGridRowPosition(endTime);
            var gridColumn = getGridColumnPosition(date, weeklyDates);
            if (!gridRowStart || !gridRowEnd || !gridColumn) {
                return;
            }
            var _a = getSplitsForEvent(eventsByDateMap, detailedEvent), splitPreviousEvent = _a.splitPreviousEvent, splitNextEvent = _a.splitNextEvent;
            var isNarrowBlock = getEventBlockHeight(gridRowStart, gridRowEnd, !!splitPreviousEvent, !!splitNextEvent) < EventBlockGridDimensions.minHeightForIcon;
            var hideIcon = isNarrowBlock;
            return (React.createElement(View, { className: "event-wrapper", dataTestId: getEventBlockWrapperTestId(id), key: getEventBlockWrapperTestId(id), style: {
                    gridRow: "".concat(gridRowStart, " / ").concat(gridRowEnd),
                    gridColumn: "".concat(gridColumn)
                } },
                React.createElement(EventBlock, { detailedEvent: detailedEvent, showIcon: !hideIcon, borderBottom: !!splitNextEvent, borderTop: !!splitPreviousEvent })));
        });
    })));
};
var EventBlockGridWrapper = styledWithTheme(View)(function () { return "\n        display: grid;\n        grid-auto-flow: column;\n        position: relative;\n        width: ".concat(EventBlockGridDimensions.width, ";\n        grid-template-columns: ").concat(EventBlockGridDimensions.gridTemplateColumns, ";\n        grid-template-rows: ").concat(EventBlockGridDimensions.gridTemplateRow, ";\n        padding: ").concat(EventBlockGridDimensions.padding, ";\n\n        .event-wrapper {\n            display: flex;\n            justify-content: center;\n            padding: ").concat(EventBlockGridDimensions.eventBlockWrapper.padding, ";\n            position: relative;\n            margin-bottom: ").concat(EventBlockGridDimensions.eventBlockWrapper.marginBottom, "px;\n        }\n    "); });
